/* eslint-disable react/jsx-pascal-case */
import React from "react";
import PropTypes from "prop-types";
import BSL_Button from "../BSL_Button";
import { API_BASE } from "../../AppConfig";
import { fetchTimeout } from "../Common";
import { Dialog, makeStyles } from "@material-ui/core";

export const useUploadStyles = makeStyles({
    image: {
        width: "100%",
        textAlign: "center",
        height: "100px",
        display: "flex",
        alignItems: "center",
        border: "1px solid #8585b1",
        justifyContent: "center",
        boxSizing: "border-box",
        objectFit: "contain",
        "&:hover": {
            backgroundColor: "#eeeeee69",
        },
    },
    input: {
        display: "none",
    },
    import_image: {
        marginLeft: "5px",
        marginTop: "5px",
        zIndex: "10",
        position: "absolute",
        textAlign: "left",
        alignItems: "flex-end",
        justifyContent: "flex-start",
    },
    closeButton: {
        position: "absolute",
        right: "30px",
    },
});

export const uploadFile = ({ file, inputRef, props, setLoading, setFileinputKey, setImage }) => {
    if (!inputRef?.current?.files) return;
    if (inputRef.current.files[0].size > 1048000 * (props.sizeLimitMB ? props.sizeLimitMB : 8)) {
        if (props.onError)
            props.onError({
                type: "warning",
                message:
                    "Error: File is too large to attach. Max size = " +
                    (props.sizeLimitMB ? props.sizeLimitMB : 8) +
                    "MB",
            });
        return;
    }

    var FR = new FileReader();

    FR.addEventListener("load", function (e2) {
        setLoading(true);

        let api_url = API_BASE() + "document/" + props.documentFolder + "/" + props.documentSaveFilename;
        fetchTimeout(
            api_url,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    document_type: props.documentType,
                    base_64: true,
                    document_name: inputRef.current.files[0].name,
                    document_save_name: props?.documentSaveFilename
                        ? props?.documentSaveFilename
                        : inputRef.current.files[0].name,
                    document_data: e2.target.result,
                    recompressImage: props.recompressImage ? props.recompressImage : false,
                    resizeImageByMaxWidth: props.resizeImageByMaxWidth ? props.resizeImageByMaxWidth : 0,
                }),
            },
            60000
        )
            .then((response) => response.json())
            .then((json) => {
                e2.target.value = null;
                setFileinputKey(Math.random().toString(36));

                if (json.Error) {
                    throw json.Error;
                }

                setLoading(false);
                setImage(e2.target.result);

                if (props.onSuccess)
                    props.onSuccess({
                        type: "success",
                        message: "Image Successfuly imported",
                        filename: json.document_filename,
                    });
            })
            .catch((e) => {
                setLoading(false);

                if (props.onError)
                    props.onError({
                        type: "error",
                        message: "Image failed to import",
                    });
            });
    });

    FR.readAsDataURL(file);
};

export const SimpleDialog = (props) => {
    const classes = useUploadStyles();
    const { onClose, open, image_url } = props;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            PaperProps={{ style: { width: "80%", maxWidth: "80%" } }}
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={open}
        >
            <object className={classes.media} data={image_url} type="image/png" onClick={handleClose}>
                <img
                    className={classes.media}
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAikAAAEYBAMAAABrc3u4AAAALHRFWHRDcmVhdGlvbiBUaW1lAFdlZCAyNyBNYXIgMjAxOSAxODo1MTo0NyArMDkzMOWZz+IAAAAHdElNRQfjAxsIHCk2av1LAAAACXBIWXMAAAsSAAALEgHS3X78AAAABGdBTUEAALGPC/xhBQAAAANQTFRFlJylJii/hwAAAGJJREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4NDAfAAHd3L3XAAAAAElFTkSuQmCC"
                    alt="Stack Overflow logo and icons and such"
                />
            </object>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <BSL_Button secondary label="Close" onClick={handleClose} style={{ marginLeft: "10px" }} />
            </div>
        </Dialog>
    );
};

uploadFile.propTypes = {
    file: PropTypes.object.isRequired,
    props: PropTypes.object.isRequired,
    setImage: PropTypes.func.isRequired,
    inputRef: PropTypes.object.isRequired,
    setLoading: PropTypes.func.isRequired,
    setFileinputKey: PropTypes.func.isRequired,
};

SimpleDialog.propTypes = {
    image_url: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string,
    mainAction: PropTypes.func,
};
